<template>
    <modal @close="$emit('close')">
        <template slot="header">
            Contact list -
            <template v-if="form._id">edit</template>
            <template v-if="!form._id">add new</template>
        </template>
        <fieldset class="mb-3" :class="{'loading-mask': loading}">
            <div class="form-group row">
                <label class="col-form-label col-lg-2">Name</label>
                <div class="col-lg-4">
                    <input type="text" class="form-control" v-model="form.name">
                </div>
            </div>
            <div class="alert alert-danger" v-if="err">{{err}}</div>
            <div class="form-group row">
                <label class="col-form-label col-lg-12">
                    <button type="button" class="btn btn-primary" @click="save()">Save</button>
                    <button class="btn btn-link" @click="$emit('close')">Cancel</button>
                </label>
            </div>
        </fieldset>
    </modal>
</template>
<script>
import modal from '../common/Modal.vue'

export default {
    components: { modal },
    props: {
        id: null,
    },
    data() {
        return {
            form: {
                _id: null,
                name: null
            },
            err: null,
            loading: false,
        }
    },
    methods: {
        save() {
            this.loading = true
            this.$api.postReq('contact_list', this.form).then(res => {
                this.$emit('close')
                this.$emit('reload')
            }).catch(res => {
                this.err = res.body.error
            })
        },
    },
    mounted() {

        if (typeof this.id !== 'string') {
            return
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/modal/ContactList.vue